<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
    <slot />
    <path
      :fill="color"
      d="M14.495 5.066L9.707.294C9.081-.333 8 .108 8 1V3c-3.61.12-8 1.153-8 5.93 0 1.004.256 1.919.71 2.73.464.828 1.135 1.549 1.95 2.145.756.553 1.6-.38 1.34-1.305-.866-3.068.2-3.364 4-3.5v2c0 .893 1.082 1.332 1.707.707l5-5c.39-.39.178-1.25-.212-1.64zM9 11V8c-4.552.041-7.28.46-6 5-.985-.72-2-2.035-2-4.069C1 4.824 4.932 4.042 9 4V1l5 5-5 5zm8.707-4.293l-5 5c-.42.42-1.046.36-1.412.003L17 6 11.295.29c.365-.356.991-.417 1.412.004l5 4.999c.39.39.39 1.024 0 1.414z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
